<template>
    <div class="login-index">
        <div style="margin: auto" class="flex_sty">
            <div class="login-index-loading-box" v-if="isLoading">
                <v-progress-circular
                    :size="140"
                    :width="7"
                    color="#6A1B9A"
                    indeterminate
                ></v-progress-circular>
                <h2 :class="$vuetify.theme.dark ? 'loading-style2': 'loading-style'" >Loading...</h2>
            </div>
            <p :class="$vuetify.theme.dark ? 'tip1_dark': 'tip1'">{{ $t("adhibition.downSAP.des") }}</p>
            <p :class="$vuetify.theme.dark ? 'tip2s': 'tip2'">{{ $t("adhibition.downSAP.noTip") }}
                <a href="/download/sap-windows.zip" v-if="downFileType == 36" download="sap-windows.zip" class="color_link" >{{ $t("adhibition.downSAP.plugIn") }}</a>
                <a href="/download/AutoLoginPlug.zip" v-if="downFileType == 32" download="AutoLoginPlug.zip" class="color_link" >{{ $t("adhibition.downSAP.plugIn") }}</a>
            </p>

        </div>
    </div>
</template>

<script>
import {reqGetAppSapGuiInfo,reqGetCsFormInfo} from "@/api/index";
import { getCookie } from '@/utils/cookie';
import { getTheme } from "@/api/index";
export default {
    data() {
        return{
            isLoading:true,
            downFileType:36,
        }
    },
    created(){
         this.initGetAppSapGuiInfo()
    },
    mounted() {
       if(!getCookie("materio-active-theme")){
        this.getThemeFun()
      }else{
        this.$vuetify.theme.dark = getCookie("materio-active-theme") == 'light'
      }
    },
  methods:{
        initGetAppSapGuiInfo(){
            let params = {
                appKey: this.$route.query.appKey,
                subUsername: this.$route.query.subUsername ? this.$route.query.subUsername : ""
            }

            if(this.$route.query.appType == 36) {
              this.downFileType = 36
              reqGetAppSapGuiInfo(params).then(res => {
                if(res.code == 200) {
                  window.location.href =  res.data
                }
              })

            }
          if(this.$route.query.protocolType == 32) {
               this.downFileType = 32
              reqGetCsFormInfo(params)
                .then(res => {
                  if(res.code == 200) {
                    window.location.href =  res.data
                  }
                })

          }

        },

        getThemeFun(){
            getTheme().then(res=> {
                if(res.code == 200) {
                    if(res.data != null) {
                        let datas = res.data
                        if(datas.materioSkinVariant != undefined) {
                            if(datas.materioSkinVariant == 1) {
                                this.$vuetify.theme.dark = true
                            }
                        }
                    }else{
                        this.$vuetify.theme.dark = false
                    }
                }
            })
        }
    }
}
</script>
<style lang='scss' scoped>
    .login-index {
        // background: linear-gradient(143deg, #2E6BF7, #2EB7F7);
        display: flex;
        height: 90%;
        .flex_sty{
            // border: 1px solid;
            justify-items: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            .loading-style{
                margin-top: 20px;
            }
            .loading-style2{
                margin-top: 20px;
                color: #fff;
            }
            .tip1{
                font-size: 18px;
                color: #333;
                margin-top: 30px;
            }
            .tip1_dark{
                font-size: 18px;
                color: #fff;
                margin-top: 30px;
            }
            .tip2{
                font-size: 14px;
                color: #949494;
                .color_link{
                    color: #5066e0;
                    text-decoration: none;
                }
            }
            .tip2s{
                font-size: 14px;
                color: #ccc;
                .color_link{
                    color: #5066e0;
                    text-decoration: none;
                }
            }
        }
    }
</style>
